import { render, staticRenderFns } from "./Clue.vue?vue&type=template&id=250f949c&scoped=true&"
import script from "./Clue.vue?vue&type=script&lang=ts&"
export * from "./Clue.vue?vue&type=script&lang=ts&"
import style0 from "./Clue.vue?vue&type=style&index=0&id=250f949c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f949c",
  null
  
)

export default component.exports